import { render, staticRenderFns } from "./SnapPhoto.vue?vue&type=template&id=068cc86b&scoped=true"
import script from "./SnapPhoto.vue?vue&type=script&lang=js"
export * from "./SnapPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068cc86b",
  null
  
)

export default component.exports